export const transition = {
    duration: 0.3,
    ease: [0.60, 0.60, 0.60, 0.60]
};